// financialApiBody is not required anymore and can be deleted 
const financialApiBody = {
    "inverterElectricalMap": {
        "micro": [],
        "string": [
            {
                "inverterDatabaseId": 5736,
                "inverterMake": "PVS-120-TL",
                "inverterManufacturer": "ABB",
                "electricalProperties": {
                    "id": 5736,
                    "image": null,
                    "deleted": false,
                    "deleted_at": null,
                    "Manufacturer": "ABB",
                    "Make": "PVS-120-TL",
                    "model": null,
                    "series": null,
                    "Source_link": "https://cdn.enfsolar.com/Product/pdf/Inverter/5bac295a532e9.PDF",
                    "Note": "",
                    "Size": 120,
                    "Number_of_MPPT": 6,
                    "Number_of_Strings": "4/4/4/4/4/4",
                    "MPPT_Low_V": 570,
                    "MPPT_High_V": 850,
                    "max_efficiency": 98.9,
                    "euro_efficiency": 98.6,
                    "nominal_dc_voltage": null,
                    "rated_dc_voltage": null,
                    "max_dc_voltage": 1000,
                    "min_dc_voltage_to_start_feed_in": 420,
                    "nominal_dc_power": null,
                    "rated_dc_power": null,
                    "max_dc_power": 123000,
                    "nominal_dc_current": null,
                    "rated_dc_current": null,
                    "max_dc_current": "36/36/36/36/36/36",
                    "power_factor_min": null,
                    "power_factor_max": 1,
                    "power_consumption_at_night": null,
                    "number_of_feed_in_phases": null,
                    "nominal_ac_voltage": [
                        0
                    ],
                    "rated_ac_voltage": null,
                    "output_ac_voltage_range_end": null,
                    "output_ac_voltage_range_start": null,
                    "nominal_ac_power": null,
                    "rated_ac_power": null,
                    "max_ac_power_VA": 120000,
                    "max_ac_power_W": 120000,
                    "nominal_ac_current": null,
                    "rated_ac_current": null,
                    "max_ac_current": 145,
                    "depth": null,
                    "height": null,
                    "weight": null,
                    "width": null,
                    "distortion": null,
                    "frequency": null,
                    "interface": null,
                    "operation_temperature_end": null,
                    "operation_temperature_start": null,
                    "protection_class": null,
                    "reference_id": null,
                    "region": null,
                    "inverter_type": null,
                    "image_link": null,
                    "organisation_specific_inverter": null
                },
                "mppts": [
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    }
                ]
            },
            {
                "inverterDatabaseId": 5736,
                "inverterMake": "PVS-120-TL",
                "inverterManufacturer": "ABB",
                "electricalProperties": {
                    "id": 5736,
                    "image": null,
                    "deleted": false,
                    "deleted_at": null,
                    "Manufacturer": "ABB",
                    "Make": "PVS-120-TL",
                    "model": null,
                    "series": null,
                    "Source_link": "https://cdn.enfsolar.com/Product/pdf/Inverter/5bac295a532e9.PDF",
                    "Note": "",
                    "Size": 120,
                    "Number_of_MPPT": 6,
                    "Number_of_Strings": "4/4/4/4/4/4",
                    "MPPT_Low_V": 570,
                    "MPPT_High_V": 850,
                    "max_efficiency": 98.9,
                    "euro_efficiency": 98.6,
                    "nominal_dc_voltage": null,
                    "rated_dc_voltage": null,
                    "max_dc_voltage": 1000,
                    "min_dc_voltage_to_start_feed_in": 420,
                    "nominal_dc_power": null,
                    "rated_dc_power": null,
                    "max_dc_power": 123000,
                    "nominal_dc_current": null,
                    "rated_dc_current": null,
                    "max_dc_current": "36/36/36/36/36/36",
                    "power_factor_min": null,
                    "power_factor_max": 1,
                    "power_consumption_at_night": null,
                    "number_of_feed_in_phases": null,
                    "nominal_ac_voltage": [
                        0
                    ],
                    "rated_ac_voltage": null,
                    "output_ac_voltage_range_end": null,
                    "output_ac_voltage_range_start": null,
                    "nominal_ac_power": null,
                    "rated_ac_power": null,
                    "max_ac_power_VA": 120000,
                    "max_ac_power_W": 120000,
                    "nominal_ac_current": null,
                    "rated_ac_current": null,
                    "max_ac_current": 145,
                    "depth": null,
                    "height": null,
                    "weight": null,
                    "width": null,
                    "distortion": null,
                    "frequency": null,
                    "interface": null,
                    "operation_temperature_end": null,
                    "operation_temperature_start": null,
                    "protection_class": null,
                    "reference_id": null,
                    "region": null,
                    "inverter_type": null,
                    "image_link": null,
                    "organisation_specific_inverter": null
                },
                "mppts": [
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    }
                ]
            },
            {
                "inverterDatabaseId": 5736,
                "inverterMake": "PVS-120-TL",
                "inverterManufacturer": "ABB",
                "electricalProperties": {
                    "id": 5736,
                    "image": null,
                    "deleted": false,
                    "deleted_at": null,
                    "Manufacturer": "ABB",
                    "Make": "PVS-120-TL",
                    "model": null,
                    "series": null,
                    "Source_link": "https://cdn.enfsolar.com/Product/pdf/Inverter/5bac295a532e9.PDF",
                    "Note": "",
                    "Size": 120,
                    "Number_of_MPPT": 6,
                    "Number_of_Strings": "4/4/4/4/4/4",
                    "MPPT_Low_V": 570,
                    "MPPT_High_V": 850,
                    "max_efficiency": 98.9,
                    "euro_efficiency": 98.6,
                    "nominal_dc_voltage": null,
                    "rated_dc_voltage": null,
                    "max_dc_voltage": 1000,
                    "min_dc_voltage_to_start_feed_in": 420,
                    "nominal_dc_power": null,
                    "rated_dc_power": null,
                    "max_dc_power": 123000,
                    "nominal_dc_current": null,
                    "rated_dc_current": null,
                    "max_dc_current": "36/36/36/36/36/36",
                    "power_factor_min": null,
                    "power_factor_max": 1,
                    "power_consumption_at_night": null,
                    "number_of_feed_in_phases": null,
                    "nominal_ac_voltage": [
                        0
                    ],
                    "rated_ac_voltage": null,
                    "output_ac_voltage_range_end": null,
                    "output_ac_voltage_range_start": null,
                    "nominal_ac_power": null,
                    "rated_ac_power": null,
                    "max_ac_power_VA": 120000,
                    "max_ac_power_W": 120000,
                    "nominal_ac_current": null,
                    "rated_ac_current": null,
                    "max_ac_current": 145,
                    "depth": null,
                    "height": null,
                    "weight": null,
                    "width": null,
                    "distortion": null,
                    "frequency": null,
                    "interface": null,
                    "operation_temperature_end": null,
                    "operation_temperature_start": null,
                    "protection_class": null,
                    "reference_id": null,
                    "region": null,
                    "inverter_type": null,
                    "image_link": null,
                    "organisation_specific_inverter": null
                },
                "mppts": [
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    }
                ]
            },
            {
                "inverterDatabaseId": 5736,
                "inverterMake": "PVS-120-TL",
                "inverterManufacturer": "ABB",
                "electricalProperties": {
                    "id": 5736,
                    "image": null,
                    "deleted": false,
                    "deleted_at": null,
                    "Manufacturer": "ABB",
                    "Make": "PVS-120-TL",
                    "model": null,
                    "series": null,
                    "Source_link": "https://cdn.enfsolar.com/Product/pdf/Inverter/5bac295a532e9.PDF",
                    "Note": "",
                    "Size": 120,
                    "Number_of_MPPT": 6,
                    "Number_of_Strings": "4/4/4/4/4/4",
                    "MPPT_Low_V": 570,
                    "MPPT_High_V": 850,
                    "max_efficiency": 98.9,
                    "euro_efficiency": 98.6,
                    "nominal_dc_voltage": null,
                    "rated_dc_voltage": null,
                    "max_dc_voltage": 1000,
                    "min_dc_voltage_to_start_feed_in": 420,
                    "nominal_dc_power": null,
                    "rated_dc_power": null,
                    "max_dc_power": 123000,
                    "nominal_dc_current": null,
                    "rated_dc_current": null,
                    "max_dc_current": "36/36/36/36/36/36",
                    "power_factor_min": null,
                    "power_factor_max": 1,
                    "power_consumption_at_night": null,
                    "number_of_feed_in_phases": null,
                    "nominal_ac_voltage": [
                        0
                    ],
                    "rated_ac_voltage": null,
                    "output_ac_voltage_range_end": null,
                    "output_ac_voltage_range_start": null,
                    "nominal_ac_power": null,
                    "rated_ac_power": null,
                    "max_ac_power_VA": 120000,
                    "max_ac_power_W": 120000,
                    "nominal_ac_current": null,
                    "rated_ac_current": null,
                    "max_ac_current": 145,
                    "depth": null,
                    "height": null,
                    "weight": null,
                    "width": null,
                    "distortion": null,
                    "frequency": null,
                    "interface": null,
                    "operation_temperature_end": null,
                    "operation_temperature_start": null,
                    "protection_class": null,
                    "reference_id": null,
                    "region": null,
                    "inverter_type": null,
                    "image_link": null,
                    "organisation_specific_inverter": null
                },
                "mppts": [
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    }
                ]
            },
            {
                "inverterDatabaseId": 5736,
                "inverterMake": "PVS-120-TL",
                "inverterManufacturer": "ABB",
                "electricalProperties": {
                    "id": 5736,
                    "image": null,
                    "deleted": false,
                    "deleted_at": null,
                    "Manufacturer": "ABB",
                    "Make": "PVS-120-TL",
                    "model": null,
                    "series": null,
                    "Source_link": "https://cdn.enfsolar.com/Product/pdf/Inverter/5bac295a532e9.PDF",
                    "Note": "",
                    "Size": 120,
                    "Number_of_MPPT": 6,
                    "Number_of_Strings": "4/4/4/4/4/4",
                    "MPPT_Low_V": 570,
                    "MPPT_High_V": 850,
                    "max_efficiency": 98.9,
                    "euro_efficiency": 98.6,
                    "nominal_dc_voltage": null,
                    "rated_dc_voltage": null,
                    "max_dc_voltage": 1000,
                    "min_dc_voltage_to_start_feed_in": 420,
                    "nominal_dc_power": null,
                    "rated_dc_power": null,
                    "max_dc_power": 123000,
                    "nominal_dc_current": null,
                    "rated_dc_current": null,
                    "max_dc_current": "36/36/36/36/36/36",
                    "power_factor_min": null,
                    "power_factor_max": 1,
                    "power_consumption_at_night": null,
                    "number_of_feed_in_phases": null,
                    "nominal_ac_voltage": [
                        0
                    ],
                    "rated_ac_voltage": null,
                    "output_ac_voltage_range_end": null,
                    "output_ac_voltage_range_start": null,
                    "nominal_ac_power": null,
                    "rated_ac_power": null,
                    "max_ac_power_VA": 120000,
                    "max_ac_power_W": 120000,
                    "nominal_ac_current": null,
                    "rated_ac_current": null,
                    "max_ac_current": 145,
                    "depth": null,
                    "height": null,
                    "weight": null,
                    "width": null,
                    "distortion": null,
                    "frequency": null,
                    "interface": null,
                    "operation_temperature_end": null,
                    "operation_temperature_start": null,
                    "protection_class": null,
                    "reference_id": null,
                    "region": null,
                    "inverter_type": null,
                    "image_link": null,
                    "organisation_specific_inverter": null
                },
                "mppts": [
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    },
                    {
                        "linkedSubarraysIds": [
                            3
                        ],
                        "stringRange": {
                            "minimum": 18,
                            "maximum": 19
                        },
                        "strings": [],
                        "maxStrings": 4,
                        "suggestedStringCount": 4
                    }
                ]
            }
        ],
        "central": [],
        "isStringing": false
    },
    "panelMap": [
        {
            "uuid": "fca6d220-0772-4fb6-b63e-90b3143fdfc0",
            "id": 3,
            "rowSpacing": 1.613,
            "tilt": 20,
            "structureType": "Default Fixed Tilt",
            "azimuth": 180,
            "moduleLength": 2.03,
            "moduleWidth": 0.98,
            "landscape": false,
            "mountHeight": 1,
            "frameSizeUp": 1,
            "frameSizeWide": 1,
            "frameSpacing": 0.025,
            "moduleSpacingUp": 0.025,
            "moduleSpacingWide": 0.025,
            "associatedObstacle": 0,
            "surfaceTilt": 0,
            "moduleProperties": {
                "moduleId": 20511,
                "moduleMake": "Waaree Energies Ltd Merlin WM-310-330-FX WM-315-FX",
                "moduleSize": 0.315,
                "moduleWidth": 0.98,
                "moduleLength": 2.03
            },
            "panelProperties": {
                "id": 20511,
                "image": null,
                "image_link": "",
                "is_selected": false,
                "characteristics": {
                    "model": "WM-315-FX",
                    "v_max": 1000,
                    "width": 0.98,
                    "length": 2.03,
                    "series": "Merlin WM-310-330-FX",
                    "p_mp_ref": 315,
                    "cell_type": "Monocrystalline",
                    "cell_number": 72,
                    "manufacturer": "Waaree Energies Ltd"
                }
            },
            "rows": [
                {
                    "id": 0,
                    "localBBox": {
                        "minX": 3.014999999999999,
                        "maxX": 9.020000000000001,
                        "minY": 3.6298660201953945,
                        "maxY": 5.537442040390789
                    },
                    "frames": [
                        {
                            "id": 1,
                            "panels": [
                                {
                                    "id": 1,
                                    "solarAccess": 0,
                                    "corners": [
                                        [
                                            2.9954070902405348,
                                            16.503260088479834,
                                            1.6943008904599899
                                        ],
                                        [
                                            2.0154070711670484,
                                            16.503260088479834,
                                            1.6943008904599899
                                        ],
                                        [
                                            2.0154070711670484,
                                            14.595684123552163,
                                            1.0000000004911178
                                        ],
                                        [
                                            2.9954070902405348,
                                            14.595684123552163,
                                            1.0000000004911178
                                        ]
                                    ]
                                }
                            ],
                            "position": {
                                "x": 2.5054070807037916,
                                "y": 15.549472106016,
                                "z": 1.3471504454755538
                            }
                        },
                        {
                            "id": 2,
                            "panels": [
                                {
                                    "id": 2,
                                    "solarAccess": 0,
                                    "corners": [
                                        [
                                            4.000407090240535,
                                            16.503260088479834,
                                            1.6943008904599899
                                        ],
                                        [
                                            3.0204070711670488,
                                            16.503260088479834,
                                            1.6943008904599899
                                        ],
                                        [
                                            3.0204070711670488,
                                            14.595684123552163,
                                            1.0000000004911178
                                        ],
                                        [
                                            4.000407090240535,
                                            14.595684123552163,
                                            1.0000000004911178
                                        ]
                                    ]
                                }
                            ],
                            "position": {
                                "x": 3.510407080703792,
                                "y": 15.549472106016,
                                "z": 1.3471504454755538
                            }
                        },
                        {
                            "id": 3,
                            "panels": [
                                {
                                    "id": 3,
                                    "solarAccess": 0,
                                    "corners": [
                                        [
                                            5.005407090240536,
                                            16.503260088479834,
                                            1.6943008904599899
                                        ],
                                        [
                                            4.0254070711670495,
                                            16.503260088479834,
                                            1.6943008904599899
                                        ],
                                        [
                                            4.0254070711670495,
                                            14.595684123552163,
                                            1.0000000004911178
                                        ],
                                        [
                                            5.005407090240536,
                                            14.595684123552163,
                                            1.0000000004911178
                                        ]
                                    ]
                                }
                            ],
                            "position": {
                                "x": 4.515407080703793,
                                "y": 15.549472106016,
                                "z": 1.3471504454755538
                            }
                        },
                        {
                            "id": 4,
                            "panels": [
                                {
                                    "id": 4,
                                    "solarAccess": 0,
                                    "corners": [
                                        [
                                            6.010407090240536,
                                            16.503260088479834,
                                            1.6943008904599899
                                        ],
                                        [
                                            5.030407071167049,
                                            16.503260088479834,
                                            1.6943008904599899
                                        ],
                                        [
                                            5.030407071167049,
                                            14.595684123552163,
                                            1.0000000004911178
                                        ],
                                        [
                                            6.010407090240536,
                                            14.595684123552163,
                                            1.0000000004911178
                                        ]
                                    ]
                                }
                            ],
                            "position": {
                                "x": 5.520407080703793,
                                "y": 15.549472106016,
                                "z": 1.3471504454755538
                            }
                        },
                        {
                            "id": 5,
                            "panels": [
                                {
                                    "id": 5,
                                    "solarAccess": 0,
                                    "corners": [
                                        [
                                            7.0154070902405365,
                                            16.503260088479834,
                                            1.6943008904599899
                                        ],
                                        [
                                            6.03540707116705,
                                            16.503260088479834,
                                            1.6943008904599899
                                        ],
                                        [
                                            6.03540707116705,
                                            14.595684123552163,
                                            1.0000000004911178
                                        ],
                                        [
                                            7.0154070902405365,
                                            14.595684123552163,
                                            1.0000000004911178
                                        ]
                                    ]
                                }
                            ],
                            "position": {
                                "x": 6.525407080703793,
                                "y": 15.549472106016,
                                "z": 1.3471504454755538
                            }
                        },
                        {
                            "id": 6,
                            "panels": [
                                {
                                    "id": 6,
                                    "solarAccess": 0,
                                    "corners": [
                                        [
                                            8.020407090240537,
                                            16.503260088479834,
                                            1.6943008904599899
                                        ],
                                        [
                                            7.040407071167051,
                                            16.503260088479834,
                                            1.6943008904599899
                                        ],
                                        [
                                            7.040407071167051,
                                            14.595684123552163,
                                            1.0000000004911178
                                        ],
                                        [
                                            8.020407090240537,
                                            14.595684123552163,
                                            1.0000000004911178
                                        ]
                                    ]
                                }
                            ],
                            "position": {
                                "x": 7.530407080703794,
                                "y": 15.549472106016,
                                "z": 1.3471504454755538
                            }
                        }
                    ]
                },
                {
                    "id": 1,
                    "localBBox": {
                        "minX": 4.019999999999999,
                        "maxX": 4.999999999999999,
                        "minY": 7.150442040390792,
                        "maxY": 9.058018060586186
                    },
                    "frames": [
                        {
                            "id": 1,
                            "panels": [
                                {
                                    "id": 7,
                                    "solarAccess": 0,
                                    "corners": [
                                        [
                                            4.000407090240535,
                                            12.982684068284438,
                                            1.6943008904599899
                                        ],
                                        [
                                            3.0204070711670488,
                                            12.982684068284438,
                                            1.6943008904599899
                                        ],
                                        [
                                            3.0204070711670488,
                                            11.075108103356765,
                                            1.0000000004911178
                                        ],
                                        [
                                            4.000407090240535,
                                            11.075108103356765,
                                            1.0000000004911178
                                        ]
                                    ]
                                }
                            ],
                            "position": {
                                "x": 3.510407080703792,
                                "y": 12.028896085820602,
                                "z": 1.3471504454755538
                            }
                        }
                    ]
                }
            ],
            "bifacialEnabled": false
        }
    ],
}

export { financialApiBody };

export const appliancesList = [
    {
        name: "Fan",
        size: 80,
        quantity: 2,
        hours: 2,
        isChecked: false,
        selected: false,
        isEssential: false
    },
    {
        name: "Tube light",
        size: 60,
        quantity: 2,
        hours: 10,
        isChecked: false,
        selected: false,
        isEssential: false

    },
    {
        name: "LED Light",
        size: 20,
        quantity: 2,
        hours: 10,
        isChecked: false,
        selected: false,
        isEssential: false

    },
    {
        name: "Fridge",
        size: 250,
        quantity: 2,
        hours: 24,
        isChecked: false,
        selected: false,
        isEssential: false

    },
    {
        name: "Water Heater",
        size: 250,
        quantity: 2,
        hours: 24,
        isChecked: false,
        selected: false,
        isEssential: false

    },
    {
        name: "Dish Washer",
        size: 250,
        quantity: 2,
        hours: 24,
        isChecked: false,
        selected: false,
        isEssential: false
    },
    {
        name: "Cooker",
        size: 250,
        quantity: 2,
        hours: 24,
        isChecked: false,
        selected: false,
        isEssential: false
    },
    {
        name: "Misc",
        size: 250,
        quantity: 2,
        hours: 24,
        isChecked: false,
        selected: false,
        isEssential: false
    },
    
]